import React from 'react';
import Text from 'components/Text/Text';

interface IProps {
	maxFileSizeMB?: number;
}

export const FileSizeLabel: React.FC<IProps> = ({ maxFileSizeMB }) => (
	<div className="mt-4 flex gap-1.5">
		<Text translationNameSpace="form" translationKey="fileSizeLabel" size="m" weight="bold" display="inline" />
		<Text
			translationNameSpace="form"
			translationKey="fileSizeValue"
			translationOptions={{ size: maxFileSizeMB }}
			size="m"
			display="inline"
		/>
	</div>
);
